import {
  GRANT_TYPE_AUTHORIZATION_CODE,
  AuthorizationServiceConfiguration,
  BaseTokenRequestHandler,
  AuthorizationNotifier,
  TokenRequest,
  AuthorizationRequest,
  RedirectRequestHandler,
  FetchRequestor,
  LocalStorageBackend,
  DefaultCrypto,
} from '@openid/appauth';
import { NoHashQueryStringUtils } from '@/noHashQueryStringUtils';

export default {
  methods: {
    getIdpAuthorizationCode(accessToken, redirect) {
      return new Promise((resolve, reject) => {
        const authorizationHandler = new RedirectRequestHandler(
          new LocalStorageBackend(window.sessionStorage),
          new NoHashQueryStringUtils(),
          window.location,
          new DefaultCrypto(),
        );
        AuthorizationServiceConfiguration.fetchFromIssuer(
          process.env.VUE_APP_IDP_AUTH_CONFIG_URL,
          new FetchRequestor(),
        )
          .then((response) => {
            const redirectUri = process.env.VUE_APP_IDP_REDIRECT_URL;
            const authRequestData = {
              client_id: process.env.VUE_APP_IDP_CLIENT_ID,
              redirect_uri: redirectUri,
              scope: process.env.VUE_APP_IDP_SCOPE,
              response_type: AuthorizationRequest.RESPONSE_TYPE_CODE,
              extras: { prompt: 'login' },
            };
            const decryptedLocation = btoa(redirect);
            authRequestData.state = decryptedLocation;
            if (accessToken) {
              authRequestData.extras.id_token = accessToken;
            }
            const authRequest = new AuthorizationRequest(authRequestData);
            authorizationHandler.performAuthorizationRequest(
              response,
              authRequest,
            );
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    getIdpToken() {
      return new Promise((resolve) => {
        const tokenHandler = new BaseTokenRequestHandler(new FetchRequestor());
        const authorizationHandler = new RedirectRequestHandler(
          new LocalStorageBackend(window.sessionStorage),
          new NoHashQueryStringUtils(),
          window.location,
          new DefaultCrypto(),
        );
        const notifier = new AuthorizationNotifier();
        authorizationHandler.setAuthorizationNotifier(notifier);
        notifier.setAuthorizationListener((request, response) => {
          if (response) {
            let extras = null;
            if (request && request.internal) {
              extras = { ...request.extras };
              extras.code_verifier = request.internal.code_verifier;
            }

            const redirectUri = process.env.VUE_APP_IDP_REDIRECT_URL;
            const tokenRequest = new TokenRequest({
              client_id: process.env.VUE_APP_IDP_CLIENT_ID,
              grant_type: GRANT_TYPE_AUTHORIZATION_CODE,
              redirect_uri: redirectUri,
              code: response.code,
              extras,
            });

            AuthorizationServiceConfiguration.fetchFromIssuer(
              process.env.VUE_APP_IDP_AUTH_CONFIG_URL,
              new FetchRequestor(),
            )
              .then((oResponse) => {
                const configuration = oResponse;
                return tokenHandler.performTokenRequest(
                  configuration,
                  tokenRequest,
                );
              })
              .then((oResponse) => {
                const cookie = `dkt-jwt-token-to-mobile=${oResponse.idToken}; secure; HostOnly; domain=.xeropan.com; path=/`;
                document.cookie = cookie;
                resolve(oResponse.accessToken);
              });
          }
        });

        authorizationHandler.completeAuthorizationRequestIfPossible();
      });
    },
  },
};
